module.exports = __webpack_public_path__ + "static/media/10.cac50aac.jpg";